import deskBookingService from '@/api/deskbooking'
import { DESK_BOOKING } from '../types'
import utils from '@/utils/utils'

export default {
  namespaced: true,
  state: {
    location: null,
    deskAttributes: [],
  },
  getters:{
    locationId: (state) => {
      return state.location
    },
    deskAttributes: (state) => {
      return state.deskAttributes
    },
  },
  mutations: {
    [DESK_BOOKING.SET_LOCATION] (state, location) {
      state.location = location
    },
    [DESK_BOOKING.SET_DESK_ATTRIBUTES] (state, deskAttributes) {
      state.deskAttributes = deskAttributes
    }
  },
  actions: {
    setLocation ({commit}, location) {
      commit(DESK_BOOKING.SET_LOCATION, location)
    },
    setDeskAttributes ({commit}, attributes) {
      commit(DESK_BOOKING.SET_DESK_ATTRIBUTES, attributes)
    },
    checkInError({dispatch}, error) {
      if (error.response && (error.response.status === 404 || error.response.status === 403 || error.response.status === 409)) {
        switch (error.response.data.error.errors[0].reason) {
          case 'bookingNotFound':
            dispatch('Global/showMessage', 'bookingNotFound', {root: true})
            break
          case 'deskNotFound':
            dispatch('Global/showMessage', 'deskNotFoundCheckIn', {root: true})
            break
          case 'inactiveDesk':
            dispatch('Global/showMessage', 'inactiveDeskCheckIn', {root: true})
            break
          case 'userNotFound':
            dispatch('Global/showMessage', 'userNotFoundCheckIn', {root: true})
            break
          case 'bookingNotInBookedState':
            dispatch('Global/showMessage', 'bookingNotInBookedStateCheckIn', {root: true})
            break
          case 'checkinTimeOutsideBookingRequest':
            dispatch('Global/showMessage', 'checkinTimeOutsideBookingRequestCheckIn', {root: true})
            break
          case 'inactiveLocation':
            dispatch('Global/showMessage', 'inactiveLocationCheckIn', {root: true})
            break
          case 'bookingNotBelongToThisUser':
            dispatch('Global/showMessage', 'bookingNotBelongToThisUserCheckIn', {root: true})
            break
          default:
            break
        }
      }
    },
    markBookingAsCheckedOutOfAnUser ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedOutOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    async pairAndMarkBookingAsCheckedInOfAnUser  ({dispatch}, payload) {
      try {
        if(payload.region === null){
          dispatch('Global/showMessage', 'noRegionError', {root: true})
          return Promise.reject()
        }
        dispatch('Global/setPairDialogHelper', true, {root: true})
        let dataPrefixWithoutTxPower = utils.createDataPrefixWithoutTxPower(payload.region.uuid, payload.region.major, payload.region.minor)
        let filters = [
          {
            manufacturerData: [{
              companyIdentifier: 0x0C01,
              dataPrefix: utils.concatTxPowerPsensor(dataPrefixWithoutTxPower)
            }]
          },
          {
            manufacturerData: [{
              companyIdentifier: 0x0C01,
              dataPrefix: utils.concatTxPowerMonitoring(dataPrefixWithoutTxPower)
            }]
        }]
        let options = {
          filters: filters,
        };
        await navigator.bluetooth.requestDevice(options)
        return dispatch('markBookingAsCheckedInOfAnUser', payload)
      }
      catch (error) {
        dispatch('Global/showMessage', 'pairingError', {root: true})
        return Promise.reject()
      }
      finally{
        dispatch('Global/setPairDialogHelper', false, {root: true})
      }
    },
    markBookingAsCheckedInOfAnUser ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskBookingService.markBookingAsCheckedInOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          dispatch('checkInError', error)
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    deleteBookingOfAnUser: function ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      return new Promise((resolve, reject) => {
        deskBookingService.deleteBookingOfAnUser(payload.location.id, payload.desk.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    }
  }
}
